import {reduxForm, Field, getFormValues, isDirty} from 'redux-form'
import {connect} from 'react-redux'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import {ActionBarWrapper} from 'components/wrappers/pages'
import SearchBar from 'components/Fields/ReduxForm/SearchBar'
import {
  onChangeOutletIds,
  exportRecipes,
  onClickCreateRecipes,
  setFilterRecipes
} from 'actions/ingredients/recipes'
import {askConfirmAction} from 'actions/confirm-action'
import styles from './ActionBar.css'
import MenuTitle from 'components/MenuTitle'
import {isFullSiteMode} from 'utils/fullSite'

class ActionBar extends React.Component {
  static NAMESPACE_OPTIONS = [
    {
      id: 'recipes', name: 'recipes'
    }
  ]

  render () {
    let {outlets} = this.props
    return (
      <div>
        <MenuTitle menuTitle='Recipes' />
        <div className='col-sm-4 hidden-xs col-md-6 action-recipe' style={{paddingRight: 0}}>
          <span className='pull-right'>
            { !isFullSiteMode() &&
              <button onClick={this._onClickExport} className='btn btn-primary ml-10px'>
                Export
              </button>
            }
            <button className='btn btn-primary ml-10px' onClick={this._onClickCreateRecipes}>
              Create Recipe
            </button>
          </span>
        </div>
        <ActionBarWrapper>
          <div className='col-sm-8 col-xs-12' style={{paddingLeft: 0}}>
            <form className={`form-inline ${styles['action-bar']}`} onSubmit={(e) => { e.preventDefault() }}>
              <div className='form-group mr-5px'>
                <Field
                  name='outletIds'
                  component={DropdownOutlet}
                  outlets={outlets}
                  onChangeOutletIds={this._onChangeOutletIds}
                  allOutletOption={false}
              />
              </div>
              <div className='form-group mr-5px'>
                <Field
                  name='search'
                  component={SearchBar}
                  placeholder='Search'
                  onChange={this._onChangeFilterKeyword}
                />
              </div>
            </form>
          </div>
        </ActionBarWrapper>
      </div>
    )
  }

  _onClickExport = () => {
    const {dispatch, search} = this.props
    let prefix = 'Recipes - '
    dispatch(exportRecipes({keyword: search.search}, prefix, search.outletIds[0]))
  }

  _onClickCreateRecipes = () => {
    const {dispatch, search, isDirtyForm} = this.props
    const {outletIds} = search
    if (isDirtyForm) {
      dispatch(askConfirmAction(onClickCreateRecipes(outletIds[0])))
    } else {
      dispatch(onClickCreateRecipes(outletIds[0]))
    }
  }

  _onChangeFilterKeyword = (event, search) => {
    const {dispatch} = this.props
    dispatch(setFilterRecipes(search))
  }

  _onChangeOutletIds = (outletIds) => {
    const {dispatch, isDirtyForm} = this.props
    if (isDirtyForm) {
      dispatch(askConfirmAction(onChangeOutletIds(outletIds)))
    } else {
      dispatch(onChangeOutletIds(outletIds))
    }
  }
}

const mapForm = {
  form: 'search'
}

function mapStateToProps (state) {
  const {outlets, showImportModal} = state.ingredients.recipes
  return {
    outlets,
    search: getFormValues('search')(state),
    isDirtyForm: isDirty('recipes')(state),
    showImportModal
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Recipes/ActionBar/ActionBar.js